import { FunctionComponent, useEffect } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import languages from '../../Data/languages';
import type { Template } from '../../types';

interface AlreadyAnsweredPageProps {
  template: Template;
}

export const AlreadyAnsweredPage: FunctionComponent<AlreadyAnsweredPageProps> = ({ template }) => {
  const appInsights = useAppInsightsContext();
  useEffect(() => {
    appInsights.trackPageView({ name: 'AlreadyAnsweredPage.tsx' });
  }, [appInsights]);
  const language = template.language.name;
  return (
    <div className="body">
      <div>
        <h2>{languages.ALREADY_ANSWERED[language]}</h2>
      </div>
    </div>
  );
};
